module.exports = __webpack_public_path__ + "assets/img/title4-818e5902.png";